import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useCallback } from 'react';
import { P as Popper } from '../Popper/Popper-BDUyDnSG.js';
import { M as MenuList } from './MenuList/MenuList-DInFEANl.js';
import { i as isEventFromWithinElement } from '../LocalModules/storm-ui-utils/dist/esm/isEventFromWithinElement-BvBeBwSW-BvBeBwSW.js';
import { K as KEYBOARD_KEYNAMES } from '../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-AmBipDtf-AmBipDtf.js';
import { a as TaktIdProvider } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { c as composeRefs } from '../LocalModules/storm-ui-utils/dist/esm/composeRefs-CHPW6wJ8-CHPW6wJ8.js';
import { O as OnRootContainerMousedown } from '../LocalModules/storm-ui-utils/dist/esm/OnRootContainerMousedown-I_k4tnAQ-BMUnuweB.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const Menu = ({
  id,
  align = 'start',
  children,
  disabled = false,
  onClose,
  onClick,
  isOpen,
  position = 'bottom',
  trigger,
  withArrow = false,
  taktId,
  taktValue,
  ...rest
}) => {
  const popperRef = useRef(null);
  const triggerRef = useRef(null);
  const onClickOutside = useCallback(event => {
    if (popperRef.current && !isEventFromWithinElement(event, popperRef.current) && !isEventFromWithinElement(event, triggerRef.current)) {
      onClose === null || onClose === void 0 || onClose(event);
    }
  }, [onClose]);
  const onClickTrigger = useCallback(event => {
    if (!disabled) {
      event.stopPropagation();
      event.preventDefault();
      onClick === null || onClick === void 0 || onClick(event);
    }
  }, [disabled, onClick]);
  const onKeyDown = useCallback(event => {
    const {
      key
    } = event;
    switch (key) {
      case KEYBOARD_KEYNAMES.ESCAPE:
      case KEYBOARD_KEYNAMES.TAB:
      case KEYBOARD_KEYNAMES.ENTER:
      case KEYBOARD_KEYNAMES.SPACE:
        onClose === null || onClose === void 0 || onClose(event);
        event.preventDefault();
        break;
    }
  }, [onClose]);
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('menu')
  }, /*#__PURE__*/React__default.createElement(Popper, _extends({
    align: align,
    autoFocus: true,
    position: position,
    isOpen: isOpen,
    popperRef: popperRef,
    padding: "none",
    spacing: 10,
    withArrow: withArrow
  }, rest, {
    onClick: onClickTrigger,
    onKeyDown: onKeyDown,
    trigger: /*#__PURE__*/React__default.cloneElement(trigger, {
      'aria-haspopup': 'menu',
      'aria-controls': `${id}`,
      'aria-expanded': isOpen,
      id: `${id}-trigger`,
      buttonRef: trigger.props.buttonRef ? composeRefs(trigger.props.buttonRef, triggerRef) : undefined,
      ref: trigger.props.buttonRef ? undefined : triggerRef,
      disabled
    })
  }), /*#__PURE__*/React__default.createElement(OnRootContainerMousedown, {
    rootContainer: typeof document !== 'undefined' ? document.documentElement : undefined,
    handler: onClickOutside
  }, /*#__PURE__*/React__default.createElement(MenuList, {
    id: `${id}`,
    "aria-labelledby": `${id}-trigger`
  }, children))));
};
Menu.defaultProps = {
  disabled: false,
  onClose: noop
};

export { Menu as M };
//# sourceMappingURL=Menu-DMRrF4Un.js.map
